import BaseNetwork from "@/lib/classes/BaseNetwork";
import { derivePubkeyFromXpub } from "@/lib/helpers/derive";

import { keccak_256 } from "@noble/hashes/sha3";

class EVM extends BaseNetwork {
  private hexToBytes(hex: string): Uint8Array {
    if (hex.startsWith("0x")) hex = hex.slice(2);
    if (hex.length % 2 !== 0) throw new Error("Invalid hex string");
    const bytes = new Uint8Array(hex.length / 2);
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = parseInt(hex.slice(i * 2, i * 2 + 2), 16);
    }
    return bytes;
  }

  private toChecksumAddress(address: string): string {
    // Remove 0x prefix and lowercase
    const addr = address.toLowerCase().replace(/^0x/, "");
    const hash = keccak_256(Buffer.from(addr, "ascii"));
    let ret = "0x";

    for (let i = 0; i < addr.length; i++) {
      // Get the byte index and nibble index inside the byte
      const hashByte = hash[i >> 1]; // byte containing two nibbles
      const nibble = i % 2 === 0 ? hashByte >> 4 : hashByte & 0x0f;

      // If nibble >= 8, uppercase the character, else lowercase
      ret += nibble >= 8 ? addr[i].toUpperCase() : addr[i];
    }

    return ret;
  }

  private deriveEthereumAddress(pubKey: Uint8Array): string {
    if (pubKey.length === 65 && pubKey[0] === 0x04) {
      pubKey = pubKey.slice(1);
    }
    if (pubKey.length !== 64) {
      throw new Error("Invalid public key length for Ethereum");
    }
    const hash = keccak_256(pubKey);
    const addressBytes = hash.slice(-20);
    const addressHex = Buffer.from(addressBytes).toString("hex");
    return this.toChecksumAddress("0x" + addressHex);
  }

  getAddress(index: number, derivationPath: number[], xpub: string): string {
    const derivedPubkey = derivePubkeyFromXpub(xpub, [
      ...derivationPath,
      index,
    ]);

    const address = this.deriveEthereumAddress(
      this.hexToBytes(derivedPubkey.uncompressed),
    );

    return address;
  }
}

export default EVM;
